module.exports = __webpack_public_path__ + "static/media/info-sign.55eadccd.svg";